import type { U2000FormStateEnumEditMode } from "../../reducer/formReducer/U2000FormState";

export interface U2000SaveHandlersParams<T extends { id: string } = any> {
  doSaveFn: (row: T, editMode: U2000FormStateEnumEditMode) => Promise<any>;
  onSuccess?: (row: T, editMode: U2000FormStateEnumEditMode) => void | Promise<void>;
  onError?: (errors: { error: any }) => void;
}

export interface U2000SaveHandlersReturn<T extends { id: string } = any> {
  saveData: (data: T, editMode: U2000FormStateEnumEditMode) => Promise<void>;
}

export function useU2000SaveHandlers<T extends { id: string } = any>({ doSaveFn, onSuccess, onError }: U2000SaveHandlersParams<T>): U2000SaveHandlersReturn<T> {
  const saveData = async (data: T, editMode: U2000FormStateEnumEditMode) => {
    try {
      const response = await doSaveFn(data, editMode);
      const row: T = response.data.result as unknown as T;

      if (onSuccess) {
        await onSuccess(row as unknown as T, editMode);
      }
    } catch (error) {
      if (onError) {
        onError({ error });
      }
    }
  };

  return { saveData };
}
